module.exports = __webpack_public_path__ + "img/Anguilla.9600b31e.svg";